<script>
    export default {
        props: {
            filter: {
                type: Object,
                default: {}
            },
            filterKey: {
                type: String
            },
            languages: {
                type: Array
            },
            defaultValue: {
                default: () => {
                    return NaN;
                }
            },
            placeholder: {
                type: String
            }
        },
        data() {
            return {
                text: null,
                language: null,
            }
        },
        created() {
            this.loadFromFilter();
        },
        computed: {
            value() {
                if (_.has(this.filter, this.filterKey)) {
                    return this.filter[this.filterKey];
                }
                if (!this.placeholder) {
                    this.placeholder = 'Search for text...';
                }

                return this.defaultValue;
            },
        },
        watch: {
            value() {
                this.loadFromFilter();
            }
        },
        methods: {
            loadFromFilter() {
                this.text = _.split(this.value, ':')[1] || '';

                let fallbackLang = _.first(this.languages);
                this.language = _.find(this.languages, {'language_code': _.split(this.value, ':')[0] || fallbackLang.language_code }) || fallbackLang;
            },
            toUrlValue() {
                return this.language.language_code + ':' + this.text;
            },
            submit() {
                // If no text gets submitted is treated like a 'reset filter' right now
                let value = this.text ? this.toUrlValue() : '';

                this.$parent.$emit('set-value', this.filterKey, value);
            }
        }
    }
</script>

<template>
    <div class="attribute-translation-filter">
        <div class="input-group input-group-sm m-t-sm">
            <input type="text" v-model="text" @keyup.enter="submit" class="form-control" :placeholder="placeholder">

            <div class="input-group-btn">
                <button class="btn btn-primary"
                        :disabled="!text"
                        @click="submit"
                        v-text="'in ' + language.language_name">
                </button>
                <button data-toggle="dropdown" class="btn btn-white dropdown-toggle" type="button">
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu pull-right">
                    <li v-for="aLanguage in languages">
                        <a @click="language = aLanguage" v-text="aLanguage.language_name"></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>